import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terminos-condiciones',
  templateUrl: './terminos-condiciones.component.html',
  styleUrls: ['./terminos-condiciones.component.scss'],
})
export class TerminosCondicionesComponent implements OnInit {
  active: boolean = false;
  selectedVersionIndex: number = 0; // Por defecto, mostramos la primera versión
  versions = [
    { title: 'Actual', date: '12/03/2024' },
    { title: 'Versión 1', date: '03/07/2020' },
    { title: 'Versión 2', date: '10/11/2023' },
    { title: 'Versión 3', date: '13/02/2024' },

    // Se añaden más versiones según sea necesario
  ];
  version1: string[] = [
  ];
  version2: string[] = [];
  version3: string[] = [
  ];
  version3_1: string[] = [
  ];
  version4: string[] = [
  ];
  version4_1: string[] = [
  ];
  constructor(private router: Router) {
    window.location.href = 'https://accounts.triidy.com/tyc/terminos-condiciones';
  }
  ngOnInit(): void {
    window.location.href = 'https://accounts.triidy.com/tyc/terminos-condiciones';

    for (let i = 1; i < 10; i++) {
      this.version1.push('/assets/images/v1/tyc_v1_page-000' + i + '.jpg');
    }
    for (let i = 1; i < 10; i++) {
      this.version2.push('/assets/images/v2/tyc_v2_page-000' + i + '.jpg');
      for (let j = 10; j < 13; j++) {
        this.version2.push('/assets/images/v2/tyc_v2_page-00' + j + '.jpg');
      }
    }
    for (let i = 1; i < 10; i++) {
      this.version3.push('/assets/images/v3/tyc_v3_page-000' + i + '.jpg');

    }
    for (let j = 10; j < 25; j++) {
      this.version3_1.push('/assets/images/v3/tyc_v3_page-00' + j + '.jpg');

    }
    for (let i = 1; i < 10; i++) {
      this.version4.push('/assets/images/v4/tyc-v4_page-000' + i + '.jpg');

    }
    for (let j = 10; j < 25; j++) {
      this.version4_1.push('/assets/images/v4/tyc-v4_page-00' + j + '.jpg');

    }
  }
  showSidebar() {
    this.active = !this.active;
  }
  download() {
    if (this.selectedVersionIndex === 0) {
      window.open('http://triidy.com/wp-content/uploads/2023/11/TERMINOS-Y-CONDICIONES-V-12-Marzo-2024.pdf', '_blank');

    } else if (this.selectedVersionIndex === 1) {
      window.open('http://triidy.com/wp-content/uploads/2020/07/TERMINOS-Y-CONDICIONES-V-1-Julio-2020.pdf', '_blank');
    } else if (this.selectedVersionIndex === 2) {
      window.open('http://triidy.com/wp-content/uploads/2023/11/TERMINOS-Y-CONDICIONES-V-2-Noviembre-2023.pdf', '_blank');
    } else if (this.selectedVersionIndex === 3) {
      window.open('http://triidy.com/wp-content/uploads/2024/02/TERMINOS-Y-CONDICIONES-V-Febrero-2024.pdf', '_blank');

    }
  }
  selectVersion(index: number) {
    this.selectedVersionIndex = index;
    this.active = false; // Cerrar sidebar al seleccionar una versión
  }
}
